module.exports = __webpack_public_path__ + "static/media/fixpix.a34db9e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dealerFeatures/fixpix.svg
// module id = 2548
// module chunks = 2